@use "../../styles/breakpoint.module.scss" as *;

.imageWrapper {
    position: relative;
}

.picture {
    display: block;
    width: 100%;
    aspect-ratio: var(--aspect-ratio);
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.overlay {
    composes: listReset from "../../styles/composable/utility.module.css";
    position: absolute;
    inset: 0;
    pointer-events: none;
}

.desktopOverlay {
    composes: overlay;

    @media ($below-mobile) {
        display: none;
    }
}

.mobileOverlay {
    composes: overlay;

    @media ($above-mobile) {
        display: none;
    }
}

.mobileSlot {
    @media ($above-mobile) {
        display: none;
    }
}

.hotspot {
    position: absolute;
    translate: -50% -50%;
    pointer-events: auto;
}

@keyframes dot-pulse {
    0%,
    100% {
        box-shadow: 0 0 8px 2px rgb(252 13 13 / 70%);
    }

    50% {
        box-shadow: 0 0 0 0 rgb(252 13 13 / 0%);
    }
}

.dot {
    position: relative;
    width: var(--spacer-40);
    height: var(--spacer-40);
    background-color: var(--overlay-black-56);
    border-radius: var(--border-radius-full);
    border: 2px solid rgb(from var(--white) r g b / 80%);

    @media (prefers-reduced-motion: no-preference) {
        transition:
            background-color 0.2s,
            border-color 0.2s;
    }

    &:hover,
    &:focus-visible,
    &[aria-expanded="true"] {
        background-color: rgb(212 63 43 / 40%);
        border-color: var(--white);

        &::after {
            scale: 0.6;
            box-shadow: 0 0 12px 4px rgb(252 13 13 / 70%);
            animation: none;
        }
    }

    // Ensures WCAG AAA-sized hitbox
    &::before {
        content: "";
        position: absolute;
        background-color: transparent;
        width: 44px;
        height: 44px;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        z-index: -1;
    }

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        width: var(--spacer-16);
        height: var(--spacer-16);
        background-color: var(--white);
        border-radius: var(--border-radius-full);
        box-shadow: 0 0 8px 2px rgb(252 13 13 / 70%);
        scale: 1;

        @media (prefers-reduced-motion: no-preference) {
            transition:
                scale 0.2s,
                box-shadow 0.2s;
            animation: dot-pulse 4s ease-in-out infinite;
            animation-delay: var(--pulse-delay, 0s);
        }
    }
}

.popover {
    z-index: 90 !important;

    @media (prefers-reduced-motion: no-preference) {
        transition: opacity 200ms ease-out;
    }

    &[data-entering],
    &[data-exiting] {
        opacity: 0;
    }

    @media ($below-mobile) {
        display: none;
    }
}

.card {
    display: flex;
    gap: var(--spacer-24);
    align-items: flex-start;
    width: 450px;
    max-width: 100%;
    padding: var(--spacer-24);
    border-radius: var(--border-radius-lg);
    background: rgb(from var(--black) r g b / 40%);
    backdrop-filter: blur(15px);

    .mobileSlot & {
        background-color: var(--black);
        border-radius: 0;
        width: 100%;
    }
}

.cardClickable {
    composes: card;
    cursor: pointer;
}

.cardPicture {
    width: 30%;
    aspect-ratio: 1;
    flex-shrink: 0;
    background-color: var(--off-white);

    @media ($below-mobile) {
        width: 25%;
    }
}

.cardImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.content {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    flex-grow: 1;
}

.sku {
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.name {
    font: var(--font-p-18);
}

.price {
    font: var(--font-p-14);
}

.favoriteButton {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.favoriteSvg {
    fill: currentColor;
}
